import api from '../../../api/api'
import { SALE_CONFIG } from '../config';

import { createContext } from "react";
import { STOCK_CONFIG } from '../../stock/config';

const SaleContext = createContext({})
export const SaleProvider = ({ children }) => {

    const getStockItems = async (setData) => {

        const url = SALE_CONFIG.requests.getStockItem.url;

        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getLotSale = async (ItemNo, setData) => {

        const url = SALE_CONFIG.requests.getStockItem.url + `/${ItemNo}/lots`;

        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getReserveCustomer = async (CustomerNo, setData) => {

        const url = SALE_CONFIG.requests.getReserveCustomer.url + `/${CustomerNo}/reserves`;

        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const PostSaleDoi = async (body, setData) => {



        const res = await api.post(SALE_CONFIG.requests.saleDoi.url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const CancelDoi = async (DoiNo, setData) => {
        const convertDoiNo = encodeURIComponent(DoiNo)
        const url = SALE_CONFIG.requests.saleDoi.url + `/${convertDoiNo}/cancel`

        const res = await api.put(url, null)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    // const downloadDoi = async(doiNo: string) {
    //     const newDoi = encodeURIComponent(doiNo);
    //     const url = SALE_CONFIG.requests.saleDoi.url + `/${newDoi}/pdf`;
    //     const res: any = await this.http.get(url, {
    //         responseType: 'arraybuffer'
    //     }).toPromise();
    //     return res;
    // }

    // async downloadPromotionPrice(promotionNo: string) {
    //     const url = SALE_CONFIG.requests.promotion.url + `/${promotionNo}/pdf`;
    //     const res: any = await this.http.get(url, {
    //         responseType: 'arraybuffer'
    //     }).toPromise();
    //     return res;
    // }

    const getDoiDetail = async (doiNo, setData) => {
        const newDoi = encodeURIComponent(doiNo);
        const url = SALE_CONFIG.requests.saleDoi.url + `/${newDoi}`;
        const res = await this.http.get(url).toPromise();
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }


    const getItemsReserveCustomer = async (CustomerNo, ReserveNo, setData) => {

        const url = SALE_CONFIG.requests.getReserveCustomer.url + `/${CustomerNo}/reserves${ReserveNo ? `/${ReserveNo}/items` : ''}`;

        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }
    const getLotsReserveCustomer = async (CustomerNo, ReserveNo, setData) => {

        const url = SALE_CONFIG.requests.getReserveCustomer.url + `/${CustomerNo}/reserves/${ReserveNo}/lots`;

        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getSaleDoi = async (branchNo, setData) => {

        let _params = '';
        let _branchNo = '';

        if (branchNo) {
            _branchNo = '?branchNo=' + branchNo;
            _params = _branchNo
        }

        const res = await api.get(SALE_CONFIG.requests.saleDoi.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getPromotionList = async (PromotionNo, sdate, edate, setData) => {

        let _params = '';
        let _PromotionNo = '';
        let _sdate = '';
        let _edate = '';

        if (PromotionNo) {
            _PromotionNo = '?promotionNo=' + PromotionNo;
            _params = _PromotionNo
        }
        if (sdate) {
            _sdate = '?sdate=' + sdate
            _params = _sdate
        }
        if (edate) {
            _edate = '?edate=' + edate;
            _params = _edate
        }

        if (PromotionNo && sdate && edate) {
            _params = '?' + PromotionNo + '&' + sdate + '&' + edate
        }

        const res = await api.get(SALE_CONFIG.requests.promotion.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getPromotionDetail = async (PromotionNo, setData) => {
        const _proNo = encodeURIComponent(PromotionNo)
        const url = SALE_CONFIG.requests.promotion.url + `/${_proNo}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const promotionAdd = async (body, setData) => {

        if (body?.PromotionHeadId) {
            const url = SALE_CONFIG.requests.promotion.url + `/${body?.PromotionNo}`;
            const res = await api.put(url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        } else {

            const res = await api.post(SALE_CONFIG.requests.promotion.url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        }

    }
    const getAllLots = async (ItemNo, setData) => {

        let _params = '';
        let _ItemNo = '';

        if (ItemNo) {
            _ItemNo = '?ItemNo' + ItemNo;
        }
        _params = _ItemNo

        const url = STOCK_CONFIG.requests.getAllLot.url + `/${ItemNo}/all-lots`;;
        const res = await api.get(url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const contextData = {
        getPromotionList: getPromotionList,
        getPromotionDetail: getPromotionDetail,
        getAllLots: getAllLots,
        getItemsReserveCustomer: getItemsReserveCustomer,
        getReserveCustomer: getReserveCustomer,
        getStockItems: getStockItems,
        getLotSale: getLotSale,
    }
    return (
        <SaleContext.Provider value={contextData}>
            {children}
        </SaleContext.Provider>
    )
}

export default SaleContext
